import { useEffect } from "react";

export default function ToastNotification({ toasts, onDismiss }) {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="fixed top-[143px] left-1/2 -translate-x-1/2 z-[2001] flex flex-col gap-2 w-80">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}

function Toast({ toast, onDismiss }) {
  useEffect(() => {
    const t = setTimeout(() => onDismiss(toast.id), 4000);
    return () => clearTimeout(t);
  }, [toast.id, onDismiss]);

  const bg = toast.type === "success" ? "bg-green-500" : toast.type === "purple" ? "bg-indigo-500" : "bg-blue-500";
  return (
    <div
      className={`${bg} text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3 animate-in`}
    >
      <span className="text-xl">{toast.icon || "ℹ️"}</span>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm">{toast.title}</p>
        {toast.message && <p className="text-xs opacity-90 truncate">{toast.message}</p>}
      </div>
      <button
        onClick={() => onDismiss(toast.id)}
        className="flex-shrink-0 w-6 h-6 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center text-xs"
      >
        ✕
      </button>
    </div>
  );
}
